import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { Wrapper, HelpIcon } from "./styled";
import HelpImg from "../../../../../../../images/Icons/help.svg";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { theme } from "./muiStyled";

const Description = (props) => {
  return (
    <MuiThemeProvider theme={theme}>
      <Tooltip title={<h1 style={{ fontSize: 14, lineHeight: 1.4, fontWeight: "400" }}>{props.text}</h1>}>
        <Wrapper>
          <HelpIcon src={HelpImg} alt="help" />
        </Wrapper>
      </Tooltip>
    </MuiThemeProvider>
  );
};

export default Description;
